import type { ProctorSpecification } from '../../shared/proctor/ProctorSpecification';

import { getProctorAllocation } from '../../shared/native-modules/tare/getProctorAllocation';

export const RnGhostwriterTest: ProctorSpecification = {
    name: 'rn_ghostwriter_test',
    buckets: {
        inactive: -1,
        control: 0,
        active: 1,
        phase_a: 2
    },
};

const RN_GHOSTWRITER_ACTIVE_BUCKET = RnGhostwriterTest.buckets.active;
const RN_GHOSTWRITER_PHASE_A_BUCKET = RnGhostwriterTest.buckets.phase_a;

export async function isRnGhostwriterActive(): Promise<boolean> {
    const allocation = await getProctorAllocation(RnGhostwriterTest);
    return allocation != null && allocation.value === RN_GHOSTWRITER_ACTIVE_BUCKET;
}

export async function isRnGhostwriterPhaseA(): Promise<boolean> {
  const allocation = await getProctorAllocation(RnGhostwriterTest);
  return allocation != null && allocation.value === RN_GHOSTWRITER_PHASE_A_BUCKET;
}
